const o={md:768,lg:1024};export{o as responsiveBreakpointsPx};
